import React, { useContext } from 'react';
import DataContext from '../Elements/eventContext';
import './Footer.css';

function Footer() {
  const contextValues = useContext(DataContext);

  const triggerMenuModal = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event('open-menu-modal'));
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="custom-footer">
      <div className="container">
        
        <div className="logo-container">
          <a href="/">
            <img src="/assets/img/Chokhi_Dhani.png" alt="Chokhi Dhani" />
          </a>
        </div>

        <div className="divider">
          <span>♦</span>
        </div>

        <div className="contact-info">
          <p>
            <a href="https://goo.gl/maps/U4in9GLkcYvvayJn8" target="_blank" rel="noopener noreferrer">
              {contextValues?.settingData?.address || "2 Riverlight Quay, London, SW11 8AW"}
            </a>
          </p>
          <p>
            <a href={"tel:" + (contextValues?.settingData?.admin_support_mobile || "+44 7485 365 962")}>
              {contextValues?.settingData?.admin_support_mobile || "+44 7485 365 962"}
            </a>
            <span style={{ margin: '0 10px', color: '#c49a6c' }}>·</span>
            <a href={"mailto:" + (contextValues?.settingData?.admin_email || "info@chokhidhani.co.uk")}>
              {contextValues?.settingData?.admin_email || "info@chokhidhani.co.uk"}
            </a>
          </p>
        </div>

        <div className="links-row">
          <a href="/">Home</a>
          <a href="/about-us">About Us</a>
          <a href="#" onClick={triggerMenuModal}>Menu</a>
          <a href="/events-and-private-dining">Events & Private Dining</a>
          {/* <a href="/terrace">Terrace</a> */}
          <a href="/kalagram">Kalagram</a>
          <a href="/gallery">Gallery</a>
          <a href="/contact">Contact</a>
        </div>

        <div className="line-separator"></div>

        <div className="social-icons">
          {contextValues?.settingData?.facebook_url && (
            <a href={contextValues.settingData.facebook_url} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
              </svg>
            </a>
          )}
          {contextValues?.settingData?.instagram_url && (
            <a href={contextValues.settingData.instagram_url} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
          )}
          {contextValues?.settingData?.twitter_url && (
            <a href={contextValues.settingData.twitter_url} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
              </svg>
            </a>
          )}
          {contextValues?.settingData?.youtube_url && (
            <a href={contextValues.settingData.youtube_url} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.07 0 12 0 12s0 3.93.501 5.814a3.016 3.016 0 0 0 2.122 2.136c1.872.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          )}
        </div>

        <div className="copyright">
          CHOKHI DHANI {currentYear} &nbsp;·&nbsp; All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}

export default Footer;
